export const SERVICE_TIMEOUT = 30000
export const SERVICE_TIMEOUT_MESSAGE = 'timeout'
